class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    console.log("this",this);

  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {

         console.log("this_onToggle",this);
    if (!this.animations) this.animations = this.content.getAnimations();

if(this.mainDetailsToggle.closest('custom-header-menu')) return;
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
     console.log("this",this);
    console.log("activeElement",document.activeElement);
    if(document.activeElement.querySelectorAll('[open]').length > 0) return
    // if(this.mainDetailsToggle.closest('custom-header-menu')) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;

    // Custom close logic
      if (this.mainDetailsToggle.open) {
        const allOpenDetails = document.querySelectorAll('custom-header-menu details[open]');
        allOpenDetails?.forEach((detail) => {
          if (detail !== this.mainDetailsToggle) {
            // Remove the open attribute
            detail.removeAttribute('open');

            // Remove .abc from the closest parent <ul>
            const parentList = detail.closest('ul.has-submenu-custom');
            if (parentList) {
              parentList.classList.remove('abc');
            }

            // Also remove .abc from any child <ul> inside this detail
            const childLists = detail.querySelectorAll('ul.has-submenu-custom');
            childLists.forEach((childUl) => {
              childUl.classList.remove('abc');
            });
          }
        });
      }


    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);



class CustomHeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.checkcust_megamanu = true;

  }
  // onToggle() {
  //   if (!this.header) return;
  //   this.header.preventHide = this.mainDetailsToggle.open;

  //   if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
  //   document.documentElement.style.setProperty(
  //     '--header-bottom-position-desktop',
  //     `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
  //   );
  // }

}

customElements.define('custom-header-menu', CustomHeaderMenu);